import React from 'react';
import { useParams } from 'react-router-dom';
import { PhotoContainerRedux } from '../components/photos/PhotoContainerRedux';

/**
 * Photos page - rendered within ProjectRouteLayout
 * Clean, compact layout without redundant headers
 */
const PhotosRedux: React.FC = () => {
  const { projectId } = useParams<{ projectId: string }>();

  return (
    <div className="absolute inset-0">
      <PhotoContainerRedux isProjectSpecific={true} projectId={projectId} />
    </div>
  );
};

export default PhotosRedux;
